// src/components/Home.js
import React, {useEffect, useRef, useState} from 'react';
import {useLocation} from 'react-router-dom';
import FAQBanner from '../../components/Banner/FAQBanner';
import LeftSidebar from '../../components/Common/LeftSidebar';
import {policyUsageData} from '../../data/policyUsageData';
import './FAQ.css';

const PolicyUsage = () => {
	const location = useLocation();
	const [selectedSection, setSelectedSection] = useState('cau-1');
	const [showMobileMenu, setShowMobileMenu] = useState(false);
	const sectionRefs = useRef({});
	
	// Policy sections data
	const policySections = policyUsageData;
	
	// Handle hash navigation
	useEffect(() => {
		const hash = location.hash.replace('#', '');
		if (hash && hash.startsWith('cau-')) {
			setSelectedSection(hash);
			// Scroll to section after a delay to ensure content is rendered
			setTimeout(() => {
				const element = sectionRefs.current[hash];
				if (element) {
					const headerHeight = 80;
					const elementPosition = element.offsetTop - headerHeight - 20;
					window.scrollTo({
						top: elementPosition,
						behavior: 'smooth'
					});
				}
			}, 300);
		}
	}, [location.hash]);
	
	const selectSection = (sectionId) => {
		setSelectedSection(sectionId);
		// Update URL with hash
		const newUrl = `${location.pathname}#${sectionId}`;
		window.history.pushState(null, '', newUrl);
	};
	
	const currentSection = policySections.find(section => section.id === selectedSection);
	
	return (
		<div className="mx-auto w-full animate-fadeIn text-sm relative">
			<FAQBanner title='Điều khoản và Chính sách Đăng Ký Sử Dụng Ví GooPay'/>
			{/* Main Content */}
			<div className="faq-container px-2 md:px-4 py-4 md:py-8 relative z-10">
				<div className="flex flex-col lg:flex-row gap-4 md:gap-6 lg:gap-8">
					<LeftSidebar
						items={policySections}
						selectedItem={selectedSection}
						onItemSelect={selectSection}
						showMobileMenu={showMobileMenu}
						setShowMobileMenu={setShowMobileMenu}
						arrowRight
					/>
					
					{/* Main Content Area */}
					<div className="flex-1">
						<div className="bg-white rounded-lg px-4 md:px-6">
							{currentSection && (
								<div
									ref={(el) => {
										sectionRefs.current[currentSection.id] = el;
									}}
								>
									<h1 className="font-bold text-lg md:text-xl text-gray-800 mb-4 md:mb-6">
										{currentSection.title}
									</h1>
									<div className="prose prose-sm max-w-none">
										<div className="text-gray-700 leading-relaxed text-sm">
											{currentSection.content}
										</div>
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PolicyUsage;
